export default class CompanyData {
  constructor(data) {
    this.data = data;
  }
}
